import { Navigation, Pagination, A11y, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ClipLoader from "react-spinners/esm/ClipLoader";

import styles from "./Slider.module.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import loadingStyles from "../../shared-styles/loading.module.css";
interface IProps {
  images: { stringValue: string }[];
  isLoading: boolean;
  isError: boolean;
}

export default function Slider({ images, isLoading, isError }: IProps) {
  if (isLoading)
    return (
      <div className={loadingStyles.loading}>
        <ClipLoader loading size={200} color="#35a257" />
      </div>
    );

  if (isError) {
    return <p>Error ...</p>;
  }

  return (
    <div className={styles.slider}>
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        navigation
        pagination={{ clickable: true }}
      >
        {images &&
          images.map((image, index: number) => {
            return (
              <SwiperSlide key={image.stringValue}>
                <img src={image.stringValue} alt={`slide${index + 1}`} />
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
}
